import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(theme => ({
  broadcastWrapper: {
    width: 320,
    height: '100%',
  },
  broadCastBox: {
    background: theme.colors.gray1,
    padding: '0  24px',
    paddingBottom: 20,
  },

  blankContent: {
    ...theme.typography.body3,
    ...theme.flex.mainSpaceBetween,
    margin: 0,
    padding: '17px 0',
    borderBottom: `1px solid ${theme.colors.gray4}`,
    marginBottom: '20px !important',
  },
  content: {
    display: 'block',
    marginBottom: 4,
  },

  contentWrapper: {
    marginBottom: 24,

    '&:last-child': {
      marginBottom: 0,
    },
  },
  date: {
    ...theme.typography.body4,
    display: 'block',
  },
  showMore: {
    color: theme.colors.mainGreen6,
    ...theme.typography.h5,
    fontWeight: 400,
    cursor: 'pointer',
  },
  secondsTitle: {
    ...theme.typography.body5,
    fontWeight: 600,
    color: theme.colors.blue6,
  },
  icon: {
    verticalAlign: 'middle',
    marginRight: 6,
  },
  learnMore: {
    color: theme.colors.mainGreen6,
    marginLeft: 4,
    cursor: 'pointer',
    '&>a': {
      '&:hover': {
        color: theme.colors.mainGreen5,
      },
    },
  },
  toRight: {
    float: 'right',
  },
  modal: {
    width: 'fit-content!important',
    '& .ant-modal-body': {
      padding: '32px 60px ',
    },
  },
  modalTitle: {
    ...theme.typography.h3,
    fontWeight: 400,
    fontSize: 18,
    color: '#9E9E9E',
    marginBottom: 24,
  },
  iconBox: {
    padding: 8,
    borderRadius: '50%',
    height: 32,
    marginRight: 16,
    marginTop: 2,
  },
  iconBlue: {
    background: theme.colors.blue6,
  },
  newIcon: {
    width: 16,
    height: 16,
    verticalAlign: 'baseline',

    '& >svg': {
      width: 14,
      height: 14,
      fill: 'white',
    },
  },
  iconGreen: {
    background: theme.colors.mainGreen6,
  },
  release: {
    display: 'flex',
    width: 692,
    borderBottom: '1px solid rgba(0, 0, 0, 0.09)',
    paddingBottom: 12,
    marginBottom: 12,
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: 0,
      marginBottom: 0,
    },
  },
  funcTitle: {
    color: theme.colors.blue6,
    ...theme.typography.h5,
    fontWeight: 600,
  },
  rightTop: {
    ...theme.flex.crossCenter,
  },
  funcDesc: {
    ...theme.typography.h5,
    fontWeight: 400,
    color: theme.colors.titleColor,
  },
  rightIcon: {
    marginLeft: 4,
    marginRight: 4,
    verticalAlign: 'middle',
    '&> svg': {
      width: 10,
      height: 10,
      fill: theme.colors.blue6,
    },
  },
  contents: {
    padding: '9px 20px',
    ...theme.typography.body2,
    background: theme.colors.gray2,
    borderRadius: 2,
    marginTop: 8,
    marginBottom: 4,
    height: 40,
  },
  contentDesc: {
    display: 'inline-block',
    width: 505,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme.colors.captionColor,
  },
  time: {
    ...theme.typography.body4,
    fontWeight: 400,

    color: theme.colors.captionColor,
  },
  right: {
    flex: 1,
  },
}));
export default useStyles;
